// Türkçe ay adları — tek kaynak (önceden ZayiRaporu/StokSayimGecmis/PuantajAylik
// kendi kopyalarını tutuyordu). Dil sabiti; master data değil.

// 0-index'li tam adlar (Date.getMonth() ile uyumlu)
export const AY_ADLARI = [
  'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
  'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık',
];

// 'YYYY-MM' parçalama için '01'..'12' anahtarlı kısa adlar
export const AY_ADLARI_KISA = {
  '01': 'Oca', '02': 'Şub', '03': 'Mar', '04': 'Nis', '05': 'May', '06': 'Haz',
  '07': 'Tem', '08': 'Ağu', '09': 'Eyl', '10': 'Eki', '11': 'Kas', '12': 'Ara',
};
